import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum TrailFinderAnswerSectionIds {
  general = 'general',
  filters = 'filters',
}

/**
 * @description Sections shared by the Trail Finder Answer detail page and edit form, in display order.
 */
export const trailFinderAnswerSections: SectionDefinition[] = [
  {
    id: TrailFinderAnswerSectionIds.general,
    title: 'General',
    description: 'The question this answers, answer text, display order, and visibility.',
    icon: InfoOutlinedIcon,
  },
  {
    id: TrailFinderAnswerSectionIds.filters,
    title: 'Affected Filters',
    description: 'Filters applied to the trail finder results when this answer is chosen. Empty groups do not filter.',
    icon: FilterAltOutlinedIcon,
  },
]
